var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Add realTime methods to a dataProvider based on a localstorage event bus.
 *
 * The publish/subscribe events happen only in the current browser - no event
 * broadcasting to other clients, except on other tabs of the same browser.
 * This is done only for testing purposes.
 *
 * @param {DataProvider} dataProvider The dataProvider to augment
 * @returns {DataProvider}
 *
 * @warning Do not use in production.
 *
 * @example
 *
 * const realTimeDataProvider = addRealTimeMethodsInLocalStorage(dataProvider);
 *
 * await realTimeDataProvider.subscribe('resource/post', (event) => {
 *    console.log(`Post ${event.payload.id} modified`);
 * });
 *
 * await realTimeDataProvider.publish('resource/post', {
 *     type: 'updated',
 *     payload: { id: 1234 }
 * })
 */
export var addRealTimeMethodsInLocalStorage = function (dataProvider) {
    var listeners = {};
    window.addEventListener('storage', function (event) {
        var topics = Object.keys(listeners);
        var topic = topics.find(function (topic) { return event.key === "__topic__".concat(topic); });
        if (topic) {
            var message_1 = JSON.parse(event.newValue);
            listeners[topic].forEach(function (callback) {
                callback(message_1);
            });
            process.env.NODE_ENV !== 'test' &&
                console.debug("Executed listeners on", topic, message_1);
        }
    }, false);
    return __assign(__assign({}, dataProvider), { publish: function (topic, message) {
            var dataKey = "__topic__".concat(topic);
            var jsonData = JSON.stringify(message);
            localStorage.setItem(dataKey, jsonData);
            // The storage event is not triggered on the current window;
            // Manually dispatch to current window
            var event = new StorageEvent('storage', {
                key: dataKey,
                newValue: jsonData,
            });
            window.dispatchEvent(event);
            process.env.NODE_ENV !== 'test' &&
                console.debug("Published to", topic, message);
            return Promise.resolve({ data: null });
        }, subscribe: function (topic, callback) {
            if (listeners[topic] == null) {
                listeners[topic] = [];
            }
            listeners[topic].push(callback);
            process.env.NODE_ENV !== 'test' &&
                console.debug("Subscribed to", topic);
            return Promise.resolve({ data: null });
        }, unsubscribe: function (topic, callback) {
            if (listeners[topic] == null) {
                return;
            }
            listeners[topic] = listeners[topic].filter(function (v) { return v.toString() !== callback.toString(); });
            process.env.NODE_ENV !== 'test' &&
                console.debug("Unsubscribed from", topic);
            return Promise.resolve({ data: null });
        } });
};
